import React from 'react'
import Layout from '../../../components/corporateAdmin/Layout'
import { Helmet } from 'react-helmet'
import Chart from '../../../components/ui/demo/Chart'

function TopSelling() {
  return (
    <div>
            <Layout>
                <Helmet>
                    <title>Admin - Top selling </title>
                </Helmet>
                <Chart title="Top selling items"/>

            </Layout>
        </div>
  )
}

export default TopSelling
